export default "__VITE_ASSET__BCWZO11g__"